import { RefObject, useState } from 'react';

import { COLORS } from '@/shared/constants/colors';
import { log } from '@/shared/utils/log';

const A4_WIDTH = 595;
const A4_HEIGHT = 842;

export const useReportGeneration = () => {
  const [loading, setLoading] = useState(false);

  const generateReport = async (
    reportRef: RefObject<HTMLDivElement>,
    onSuccess: (data: string | null) => void,
  ) => {
    if (!reportRef.current) return;
    setLoading(true);

    try {
      const html2canvas = (await import('html2canvas')).default;
      const canvas = await html2canvas(reportRef.current, {
        useCORS: true,
        scale: 2,
        logging: false,
        backgroundColor: COLORS.white,
        width: A4_WIDTH,
        height: A4_HEIGHT,
      });

      onSuccess(canvas.toDataURL());
    } catch (error) {
      log.error('Failed to generate report', error);
    }
    setLoading(false);
  };

  return {
    generateReport,
    loading,
  };
};
